import React, { FC } from 'react';
import { Wrapper } from '@src/components/Wrapper';
import { StartTargetingTalent } from './StartTargetingTalent';
import { OpeningsSection } from './OpeningsSection';
import './styles.scss';

export const Openings: FC = () => {
  return (
    <div className="openings">
      <div className="openings_header">
        <div className="openings_header-title">Your jobs</div>
      </div>

      <div className="openings__divider" />

      <Wrapper>
        <>
          <StartTargetingTalent />

          <OpeningsSection />
        </>
      </Wrapper>
    </div>
  );
};
